import type { GlyphName } from "@/components/landing/shared";
import { Glyph } from "@/components/landing/shared";

const BULLET_ICONS: GlyphName[] = ["truck", "clock", "rules", "pin"];

interface DeliveryBulletsProps {
	bullets: string[];
}

function DeliveryBullets(prop: DeliveryBulletsProps) {
	const { bullets } = prop;
	return (
		<div className="mx-auto mt-10 grid max-w-4xl gap-4 px-6 sm:grid-cols-2">
			{bullets.map((bullet, i) => (
				<div key={bullet} className="flex items-center gap-3">
					<Glyph
						name={BULLET_ICONS[i % BULLET_ICONS.length]}
						className="h-5 w-5 shrink-0 text-[var(--brand-2)]"
					/>
					<p className="text-sm font-medium">{bullet}</p>
				</div>
			))}
		</div>
	);
}

export default DeliveryBullets;
